module.exports = __webpack_public_path__ + "static/media/terms.5d0699ec.md";